import React, { useState } from 'react';
import './Login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = () => {
  if (username !== 'Admin') {
    alert("Username tidak diizinkan!");
    return;
  }

  if (password === 'admin123') {
    localStorage.setItem("admin", "true");
    localStorage.setItem("username", username);
    window.location.reload();
  } else {
    alert("Password salah!");
  }
};


  return (
    <div className="login-container">
      <div className="login-box">
        <h2 className="login-title">KOMDIGI303</h2>
        <p className="login-quote">"Site Check Nawala Free, Without Pay anything"</p>

        <input
          type="text"
          placeholder="Masukkan username"
          value={username}
          onChange={e => setUsername(e.target.value)}
          className="login-input"
        />

        <input
          type="password"
          placeholder="Masukkan password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          className="login-input"
        />

        <button onClick={handleLogin} className="login-button">Login</button>
      </div>
    </div>
  );
};

export default Login;
